<div class="adresses-locator-container w-full" [formGroup]="formGroup">
	<!-- SEARCH AND FORM SECTION -->
	<ng-container *ngIf="mode === AdressesLocatorModeEnum.SearchAndForm || mode === AdressesLocatorModeEnum.Full">
		<div class="flex flex-column gap-3">
			<span class="font-bold">{{ translations['enterLocation'] || 'Enter a location' }}</span>
			<div class="search-row flex flex-row gap-2 align-items-center">
				<div class="search-input-wrapper relative flex-1 w-full">
					<app-input
						#locationInput
						class="w-full"
						type="text"
						[placeholder]="translations['pleaseEnterAddress'] || ''"
						[(ngModel)]="searchAddressInput"
						[ngModelOptions]="{ standalone: true }"
						(inputChange)="onAddressInputChange($event)"
						(blur)="onInputBlur()"
					></app-input>

					<!-- AUTOCOMPLETE FLOATING DROPDOWN -->
					<div *ngIf="autocompleteResults$ | async as results" class="autocomplete-dropdown-wrapper">
						<ul *ngIf="results && results.length > 0" class="autocomplete-list shadow-4">
							<li
								*ngFor="let result of results"
								(mousedown)="selectAutocomplete(result); $event.preventDefault()"
							>
								<app-icon iconName="map-pin" class="autocomplete-icon mr-2"></app-icon>
								<span class="autocomplete-text">{{ result.description }}</span>
							</li>
						</ul>
					</div>
				</div>

				<button
					type="button"
					(click)="findUserLocation()"
					class="location-btn p-2 border-round border-none flex align-items-center justify-content-center cursor-pointer flex-shrink-0"
				>
					<app-icon iconName="location" class="text-2xl location-icon"></app-icon>
				</button>
			</div>

			<div
				class="w-full"
				*ngIf="!isPickup && ((IsModal && (isAddressAvailable$ | async) === false) || (!IsModal && storeInDelivery !== undefined && storeInDelivery !== null && storeInDelivery.length === 0))"
			>
				<span class="text-sm font-light text-error">*{{ translations['noDelivery'] || 'No delivery in this Address' }}</span>
			</div>

			<!-- DELIVERY ADDRESS DETAILS FORM -->
			<div *ngIf="(orderType$ | async) == 'Delivery'" class="flex flex-column gap-3 mt-2">
				<div class="flex flex-column w-full">
					<app-input
						id="apartment"
						type="text"
						formControlName="apartment"
						controlId="apartment"
						[control]="formGroup.get('apartment')"
						[label]="translations['apartmentSuite'] || ''"
						[placeholder]="(translations['apartmentSuite'] || '').toUpperCase()"
						[errorMessages]="errorMessages"
						(inputChange)="onApartmentOrSuiteChange($event)"
					></app-input>
				</div>

				<div class="flex flex-column w-full">
					<app-input
						id="instructions"
						type="text"
						formControlName="instructions"
						controlId="instructions"
						[control]="formGroup.get('instructions')"
						[label]="translations['deliveryInstructions'] || ''"
						[placeholder]="translations['exampleInstructions'] || ''"
						[errorMessages]="errorMessages"
						(inputChange)="onDeliveryInstructionsChange($event)"
					></app-input>
				</div>

				<div class="flex align-items-center gap-2">
					<input
						type="checkbox"
						id="save-address"
						formControlName="save"
						class="cursor-pointer"
						(change)="onFavoriteChange($event)"
					/>
					<label for="save-address" class="cursor-pointer text-sm font-normal">
						{{ translations['saveAddress'] || 'Save address' }}
					</label>
				</div>

				<div class="flex flex-column w-full" *ngIf="showNameAddressInput">
					<app-input
						id="addressName"
						type="text"
						formControlName="addressName"
						controlId="addressName"
						[control]="formGroup.get('addressName')"
						[label]="translations['addressName'] || 'Address Name*:'"
						[placeholder]="translations['exampleAddressName'] || ''"
					></app-input>
				</div>

				<div class="flex w-full mt-2">
					<app-button
						type="button-primary"
						class="w-full"
						[text]="showNameAddressInput ? (translations['saveAndConfirmDelivery'] || 'Save and confirm Delivery') : (translations['confirmDelivery'] || 'Confirm Delivery')"
						[disabled]="(isAddressAvailable$ | async) === false"
						(buttonClicked)="confirmDeliveryAddress()"
					></app-button>
				</div>
			</div>
		</div>
	</ng-container>

	<!-- SAVED ADDRESSES SECTION -->
	<ng-container *ngIf="mode === AdressesLocatorModeEnum.SavedAddresses || mode === AdressesLocatorModeEnum.Full">
		<div class="saved-addresses-section flex flex-column gap-3 w-full" *ngIf="isLoggedIn">
			<span class="font-bold">{{ translations['savedAddress'] || 'Saved Address' }}</span>

			<div class="saved-addresses-list flex flex-column gap-2 w-full">
				<ng-container *ngFor="let addr of address$ | async">
					<div
						class="saved-address-card flex align-items-center justify-content-between p-3 border-round border-1 surface-border hover:surface-100 cursor-pointer w-full"
						(click)="onAddressClick(addr)"
					>
						<div class="flex align-items-center gap-3">
							<app-icon iconName="map-pin" class="text-xl pin-icon"></app-icon>
							<div class="flex flex-column">
								<span class="font-semibold text-sm">{{ addr.nombre }}</span>
								<span class="text-xs text-500">{{ addr.direccion1 }}</span>
							</div>
						</div>
						<div class="flex align-items-center">
							<span class="text-xs text-primary font-bold">{{ translations['select'] || 'Select' }}</span>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
	</ng-container>
</div>
